import * as ep from "../../endpoints";
import api from "@/libs/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    messages: [],
    pagination: {},
  },
  getters: {
    messages(state) {
      return state.messages;
    },
    loading(state) {
      return state.loading;
    },
    pagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setMessages(state, payload) {
      state.messages = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    async fetchMessages({ commit }, { page }) {
      commit("setLoading", true);
      await api
        .get(ep.MESSAGES, {
          params: {
            page,
          },
        })
        .then((res) => {
          commit("setMessages", res.data.data);
          commit("setPagination", res.data.pagination);
        })
        .catch((err) => {})
        .finally(() => {
          commit("setLoading", false);
        });
    },
  },
};
